import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

// D8.7.4 — Diálogo SvcDialog (presentacional).
export default function SvcDialog({ svcDialogOpen, setSvcDialogOpen, svcDialogMode, svcDialogData, setSvcDialogData, svcDialogSaving, handleSaveServiceDialog }) {
  return (
          <Dialog open={svcDialogOpen} onClose={() => setSvcDialogOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>
              {svcDialogMode === "create" ? "Agregar servicio" : "Editar servicio"}
            </DialogTitle>
            <DialogContent>
              <TextField
                label="Nombre del servicio"
                fullWidth
                margin="dense"
                variant="outlined"
                value={svcDialogData.serviceName}
                onChange={(e) => setSvcDialogData(p => ({ ...p, serviceName: e.target.value }))}
              />
              <TextField
                label="Descripción"
                fullWidth
                margin="dense"
                variant="outlined"
                value={svcDialogData.description}
                onChange={(e) => setSvcDialogData(p => ({ ...p, description: e.target.value }))}
              />
              <Box style={{ display: "flex", gap: 8, marginTop: 4 }}>
                <TextField
                  label="Duración (min)"
                  type="number"
                  margin="dense"
                  variant="outlined"
                  style={{ flex: 1 }}
                  value={svcDialogData.durationMin}
                  onChange={(e) => setSvcDialogData(p => ({ ...p, durationMin: e.target.value }))}
                  inputProps={{ min: 1 }}
                />
                <TextField
                  label="Precio (S/)"
                  type="number"
                  margin="dense"
                  variant="outlined"
                  style={{ flex: 1 }}
                  value={svcDialogData.price}
                  onChange={(e) => setSvcDialogData(p => ({ ...p, price: e.target.value }))}
                  inputProps={{ min: 0, step: "0.01" }}
                />
              </Box>
              <FormControl fullWidth margin="dense" variant="outlined">
                <InputLabel>Requiere profesional</InputLabel>
                <Select
                  value={svcDialogData.requiresProfessional ? "si" : "no"}
                  onChange={(e) => setSvcDialogData(p => ({ ...p, requiresProfessional: e.target.value === "si" }))}
                  label="Requiere profesional"
                >
                  <MenuItem value="si">Sí</MenuItem>
                  <MenuItem value="no">No</MenuItem>
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setSvcDialogOpen(false)}>Cancelar</Button>
              <Button
                onClick={handleSaveServiceDialog}
                disabled={svcDialogSaving || !svcDialogData.serviceName.trim()}
                color="primary"
                variant="contained"
              >
                {svcDialogSaving ? "Guardando…" : "Guardar"}
              </Button>
            </DialogActions>
          </Dialog>
  );
}
